import { TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

type RestaurantListSearchProps = {
  value: string;
  onChange: (value: string) => void;
  totalCount: number;
};

const RestaurantListSearch: React.FC<RestaurantListSearchProps> = ({ value, onChange }) => (
  <TextInput
    placeholder="Search restaurant"
    leftSection={<IconSearch size={16} />}
    size="sm"
    value={value}
    styles={{
      input: {
        borderRadius: 8,
        backgroundColor: 'var(--mantine-color-gray-0)',
      },
    }}
    onChange={(event) => onChange(event.currentTarget.value)}
  />
);

export default RestaurantListSearch;
